export const PUBLIC_PATHS = new Set([
  '/',
  '/naplex',
  '/naplex-prep',
  '/ptcb',
  '/ptcb-prep',
  '/mpje',
  '/mpje-prep',
  '/blog',
  '/terms',
  '/privacy',
  '/signup',
  '/login',
  '/forgot-password',
  '/reset-password',
  '/preview/public-shell',
  '/play',
  '/compendium',
]);

// When the app is served under a path prefix (PUBLIC_URL=/debono on the moth hub),
// window.location.pathname carries that prefix but PUBLIC_PATHS is written in
// app-relative terms. Strip the mount before matching, or every public page reads as
// private: a 401 on the landing then tries a refresh, fails, and redirects to a
// root-absolute /login that escapes the mount entirely — the app never mounts and the
// screen stays black. PUBLIC_URL is '' on prod, so this is a no-op there.
const stripMount = (pathname) => {
  const base = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');
  if (!base || !pathname) return pathname;
  if (pathname === base) return '/';
  return pathname.startsWith(base + '/') ? pathname.slice(base.length) : pathname;
};

const normalizePathname = (pathname) => {
  if (!pathname) return '/';
  const mounted = stripMount(pathname);
  if (!mounted) return '/';
  return mounted === '/' ? '/' : mounted.replace(/\/+$/, '');
};

export const isPublicPath = (pathname) => {
  const normalizedPathname = normalizePathname(pathname);

  return (
    PUBLIC_PATHS.has(normalizedPathname) ||
    normalizedPathname.startsWith('/blog/') ||
    normalizedPathname.startsWith('/og-render/') ||
    normalizedPathname.startsWith('/preview/') ||
    // Finerenone shareable demo: /play and /play/:slug are no-login public.
    normalizedPathname.startsWith('/play/') ||
    // Debono Compendium: /compendium plus every sub-path is no-login public. The trailing slash
    // is load-bearing — startsWith('/compendium') would quietly make a future /compendiumadmin
    // publicly reachable, and nothing would visibly break.
    normalizedPathname.startsWith('/compendium/')
  );
};
